module.exports = __webpack_public_path__ + "img/fog.42604f6d.png";